import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { RoleFilters } from '../types';

const defaults: RoleFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  status: undefined,
  type: undefined,
};

const numberFields: (keyof RoleFilters)[] = ['limit', 'page'];

export function useRoleFilters(initialFilters: Partial<RoleFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<RoleFilters>({ defaults: mergedDefaults, numberFields });
}
